import { render, staticRenderFns } from "./modal_followup.vue?vue&type=template&id=2fdeceb0&scoped=true&"
import script from "./modal_followup.vue?vue&type=script&lang=js&"
export * from "./modal_followup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdeceb0",
  null
  
)

export default component.exports